export * from "@/constants/api-routes"
import { DOMAIN } from "@/constants/env"

// Page/model route paths
export const FRAUD_DECLINED_MESSAGE_ENDPOINT = "/en/declined"
export const CHANGE_PASSWORD_MODEL_DATA_URL =
  "/en/my-account/change-password.model.json"
export const PRODUCT_BEST_SELLERS = "/products/best-sellers"
export const MY_LISTS_PAGE_PATH = "/my-account/my-lists"
export const FAVORITES_PAGE_PATH = "/my-account/my-favorites"

// Shared page/model/path constants
export const PRODUCT_GLOBALCONFIG_DATA_URL = `.globalconfig.json`
export const shippingCostEndPoint = "/checkout/shipping-cost"
export const shipmentFromCartEndPoint = "/checkout/v2/assign/shipmentfromcart"
export const searchPdpEndPoint = "/search/pdp"
export const getPdpTooltipEndPoint = "/search/tooltip"
export const MODEL_JSON_EXTENSION = ".model.json"
export const dimensionsDataEndPoint = "/search/plp"
export const findAllStores = "/maps/store"
export const HELP_AND_FAQ_SUPPORT = "/en/support/help-and-faq"
export const VISUAL_SEARCH_ALLOWED_URLS = ["/en/support/find-a-service-part"]
export const skuBypimLookup = `/scout/service/api/customer/mavenoid`
export const STORE_APPOINTMENT_ANCHOR_VALUE = "#StoreAppointment"
export const RETURN_SLIPS_API_ENDPOINT = "/return/slip"
export const RETURN_SLIPS_PAGE_URL = "returns/return-slips"
export const DECLINED_PAGE_URL = "/declined"
export const DISABLE_SROLL_PATH = [
  "home-energy/home-generators",
  "buying-guides/bath-tub-buying-guide",
  "services/installation-services",
]
export const DISABLE_SCROLL_PATH = DISABLE_SROLL_PATH

// Customer-facing site paths and hashes
export const PRESS_ROOM_PATH = "/en/press-room"

export const SUPPORT_CENTER_PATH = "/en/support/product-support-center"
export const MY_LISTS_PATH = "/en/my-account/my-lists"
export const SHARE_LIST_PATH = "/en/share-list"
export const SHARE_LIST_PATH_FR = "/fr/share-list"
export const LOCATION_PATH_FR = "/fr/locations"

export const HELP_AND_FAQ = "help-and-faq"

export const FIND_A_PRO_PATH = "/en/services/find-a-pro"
export const FIND_A_PRO_HASH = "#findapro"

export const INSTALLATION_SERVICES_HASH = "#InstallService"
export const INSTALLATION_SERVICES_PATH = "/en/services/installation-services"
export const INSTALLATION_SERVICES_ASPATH = "installation-services"
export const BUYING_GUIDE_ASPATH = "buying-guides"
export const SIGNUP_HASH = "#signup"

export const CART_URL = "/en/cart"
export const CHECKOUT_URL = "/en/checkout"
export const TECHNICAL_SPECIFICATION_PATH =
  "/en/for-professionals/technical-specifications"

export const BROWSE_ALL_STORES = "browse-all-stores"
export const BROWSE_ALL_STORES_URL = "/locations/browse-all-stores"

export const MY_LISTS_PATH_FR = "/fr/my-account/my-lists"
export const LOCATIONS_PATH = "/en/locations"
export const LOCATIONS_ASPATH = "/locations"

export const CONTACT_US_PAGE_URL_US = "/en/support/contact"
export const CONTACT_US_PAGE_URL = "/support/contact"

export const REMEDY_MODEL_JSON = "/remedy.model.json"
export const SMART_TOILETS_MODEL_JSON = "/smart-toilets.model.json"

// Commerce/cart/checkout/profile endpoint routes
export const getCartEndPoint = "/cart/active?expand=calculation"
export const createCartEndPoint = "/cart/create"
export const getStockEndPoint = "/catalog/inventory"
export const cartItemsEndPoint = "/cart/v2/items"
export const sharedCartItemsEndPoint = "/cart/items"

export const discountEndPoint = "cart/v2/discount?expand=calculation"
export const taxEndPoint = "/cart/v2/items?expand=calculation"
export const shareCartEndPoint = "/cart/sharedcart"
export const mergeCartEndPoint = "/cart/merge?expand=calculation"
export const signupEndPoint = "/customer/signup"
export const deleteCartEndPoint = "/cart/v2/deleteActiveCart"
export const addAddressEndPoint = "/customer/address"
export const addressSuggestionEndPoint = "/maps/address/validate"
export const orderSubmitEndPoint = "/checkout/v2/order/submit"
export const paymentEndPoint = "/checkout/payment"
export const payPalPaymentEndPoint = "/payment/paypal/getToken"
export const searchPlpEndPoint = "/search/plp"
export const inPageSearchEndPoint = "/search/plp"
export const searchProfilePlpEndPoint = "/search/profile"

export const MY_PRODUCTS_ENDPOINT = "/shopping-list/MyProducts"
export const FETCH_PRODUCT_REG_ENDPOINT = "/crm/fetchproductregistration"
export const FAVORITES_LIST_END_POINT = "/shopping-list/FavoriteLists"
export const USER_LIST_DELETE_END_POINT = "/shopping-list"
export const USER_LIST_PRODUCT_DELETE_POINT = "/shopping-list/remove/items"

// Domain/grouped membership, favorites, profile, and support routes
export const favoritesEndPoint = "/shopping-list/Favorites"
export const createFavoritesEndPoint = "/shopping-list/create"
export const addFavoritesEndPoint = (id, type) => {
  return `/shopping-list/add/${id}?type=${type}`
}
export const removeFavoritesEndPoint = id => {
  return `/shopping-list/remove/items/${id}`
}

export const locationIpEndPoint = "/maps/location/ip/"
export const locationZipEndPoint = "/maps/location/zipcode/"
export const GET_PROFILE_ENDPOINT = "/customer/me"
export const ZIP_FILE_DOWNLOAD_ENDPOINT = "/catalog/zip-file-download"
export const SEARCH_PLP_ENDPOINT = "search/plp"
export const MY_ACCOUNT_PATH = "/my-account"
export const emailSubscribeEndPoint = "/crm/newsletter/subscription"
export const editAddressEndPoint = "customer/address"
export const SPLIT_ORDER = "checkout/ordersplit"

export const KEY_SPECIFIER_QUERY_SELECTOR_URL = 'a[href="#KeySpecifier"]'
export const KEY_SPECIFIER_QUERRY_SELECTOR_URL =
  KEY_SPECIFIER_QUERY_SELECTOR_URL
export const KEY_SPECIFIER_API_URL_ENDPOINT = "/membership/assign/persona"
export const MEMBERSHIP_API_URL_ENDPOINT = "/membership/kohler-associate/entry"
export const MEMBERSHIP_QUERY_SELECTOR_URL = 'a[href="#AssociateMembership"]'
export const MEMBERSHIP_QUERRY_SELECTOR_URL = MEMBERSHIP_QUERY_SELECTOR_URL
export const FRIENDS_AND_FAMILY_QUERY_SELECTOR_URL =
  'a[href="#FriendsAndFamily"]'
export const FRIENDS_AND_FAMILY_QUERRY_SELECTOR_URL =
  FRIENDS_AND_FAMILY_QUERY_SELECTOR_URL
export const FRIENDS_AND_FAMILY_API_URL_ENDPOINT = "/membership/assign/persona"

export const HELP_FAQ_END_POINT = "/search/plp"
export const HELP_FAQ_ENDPOINT = HELP_FAQ_END_POINT
export const GET_ORDER_DETAILS_ENDPOINT = "checkout/orders"
export const DEFAULT_CARD_DETAILS_API_PATH =
  "/bin/kohler/services/list?path=/content/kohler"
export const MY_SERVICES_ENDPOINT =
  "/shopping-list/MyServices?lang=" + process.env.NEXT_PUBLIC_LOCALE
export const MY_FAVORITES_ENDPOINT = "/shopping-list/Favorites"

export const MY_PRODUCT_SEARCH_CATALOG = "/search/full-catalog"
export const MY_PRODUCT_PRODUCT_REGISTRATION = "/crm/product/registration"
export const PDP_TEASER_DETAILS = `${DOMAIN}/api/pdpTeaserDetails`

export const CONTACT_US_VALIDATE_RECAPTCHA_ENDPOINT = "/crm/webtocase"

// Search route URLs
export const SEARCH_PAGE_URL = "/content/kohler/us/en/search.html"

// Backward compatible aliases.
export const searchUrl = SEARCH_PAGE_URL
